export default __webpack_public_path__ + "static/media/shenqingNew.5c78de81.png";